import _ from 'lodash';

import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { KeyboardArrowDownOutlinedIcon } from '../../constants/images';
import { handleColorSystem } from '../customComponent/colorSystem';

const SelectForm = (props) => {
  const {
    id,
    selectValue,
    setValue,
    menuData,
    media,
    disabled
  } = props;

  const { colorSystem, mainColor, lightColor, darkColor, w01Color } = handleColorSystem(media);

  const handleChangeValue = (e) => {
    const { value } = e.target;

    setValue(prev => {
      _.set(prev, id, value);
      return { ...prev }
    });
  }


  return (
    <>
      <Select
        id={id}
        value={disabled ? '' : selectValue}
        IconComponent={KeyboardArrowDownOutlinedIcon}
        onChange={handleChangeValue}
        disabled={disabled}
        MenuProps={{
          style: { maxHeight: '400px' }
        }}
        sx={{
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: mainColor
          }
        }}
      >
        {
          menuData.map((data, index) => {
            return (
              <MenuItem
                key={data}
                value={index}
                sx={{
                  "&.Mui-selected": {
                    backgroundColor: w01Color
                  }
                }}
              >
                {data}
              </MenuItem>
            )
          })
        }
      </Select>
    </>
  )
}

export default SelectForm;